import * as React from "react";
import { Button, Paragraph } from "scuid-x";
import * as CaptureButtonImage from "../../assets/images/manual-capture-button.svg";
import { DocType } from "../../constants/DocType";
import { PrettyIdNames } from "../../constants/PrettyIdNames";
import "./CameraInfoPopup.css";

export interface CameraInfoPopupProps {
  docType: DocType;
  isManual: boolean;
  onDone: () => void;
}

export const CameraInfoPopup: React.SFC<CameraInfoPopupProps> = (props) => {
  const idName = PrettyIdNames.getIdNames(props.docType).shortName;

  let text;
  if (props.isManual) {
    text = (
      <Paragraph>
        Please place your {idName} on a plain dark background and get all 4 corners in the frame. When you are ready,
        press the capture button <img src={CaptureButtonImage}/> to take a picture.
      </Paragraph>
    );
  } else {
    text = (
      <Paragraph>
        Place your {idName} on a plain dark background and get all 4 corners in the frame. We'll automatically
        capture the image when everything looks good!
      </Paragraph>
    );
  }

  return (
    <div className={"CameraInfoPopup-container"}>
      {text}
      <Button
        onClick={props.onDone}
      >
        Got it
      </Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/camera/CameraInfoPopup.tsx